import { ListEntity } from "model";

export interface ListItemResponse {
  key: string;
  lang: string;
  shortDisplay: string;
  longDisplay: string;
}

export interface ListResponse {
  items: ListItemResponse[];
}

export const toListEntity = (country: ListItemResponse): ListEntity => ({
  id: country.key,
  name: country.longDisplay
})

export const toListEntityList = (response: ListResponse): ListEntity[] => response.items.map(d => toListEntity(d));
